import router from '@/router'
import { getUserInfo } from '@/utils/native-app'

router.beforeEach((to, from, next) => {
  getUserInfo().then(() => {
    next()
  })
})
